var _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefund = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#B7E3E2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6064 8.38986V6.03384C16.6064 5.75731 16.8462 5.53313 17.1419 5.53313C17.4376 5.53313 17.6774 5.75731 17.6774 6.03384V8.38986L18.3697 7.7425C18.5788 7.54696 18.9178 7.54696 19.127 7.7425C19.3361 7.93804 19.3361 8.25507 19.127 8.4506L17.5205 9.95271C17.3114 10.1482 16.9724 10.1482 16.7633 9.95271L15.1568 8.4506C14.9477 8.25507 14.9477 7.93804 15.1568 7.7425C15.366 7.54696 15.705 7.54696 15.9141 7.7425L16.6064 8.38986Z",
    fill: "#15584F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1527 11.0448H21.9772H21.7385H21.4997H19.6778H12.9832H12.1053H11.3661H11.229H10.7701C10.5268 11.0448 10.3096 11.1572 10.1679 11.3343C10.1033 11.416 10.054 11.5099 10.0263 11.6131C10.0093 11.6778 9.99854 11.7455 9.99854 11.8148V11.9072V12.7851V20.3945C9.99854 20.8196 10.3435 21.1646 10.7686 21.1646H22.1512C22.5763 21.1646 22.9212 20.8196 22.9212 20.3945V18.2461H18.3519C17.6296 18.2461 17.0428 17.6594 17.0428 16.9371V16.2317V15.993V15.7543V15.2245C17.0428 14.8703 17.1845 14.5485 17.414 14.3128C17.6172 14.1034 17.8898 13.9617 18.1948 13.9263C18.2456 13.9201 18.2979 13.917 18.3503 13.917H22.2806H22.5193H22.758H22.9212V11.8148C22.9228 11.3898 22.5778 11.0448 22.1527 11.0448Z",
    fill: "#15584F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4625 14.6534C23.3855 14.5826 23.2946 14.5286 23.193 14.4932C23.1144 14.4671 23.0313 14.4517 22.9435 14.4517H22.9235H22.9081H22.6694H21.8085H18.3526C17.9275 14.4517 17.5825 14.7966 17.5825 15.2217V15.6052V15.8439V16.0826V16.9358C17.5825 17.3608 17.9275 17.7058 18.3526 17.7058H22.9235H22.9435C23.0313 17.7058 23.1144 17.6904 23.193 17.6642C23.2946 17.6303 23.3855 17.5749 23.4625 17.5041C23.6165 17.3639 23.7135 17.1606 23.7135 16.9358V15.2217C23.7135 14.9968 23.6165 14.7935 23.4625 14.6534ZM19.9604 16.232C19.9604 16.4445 19.7879 16.617 19.5754 16.617H19.3197C19.1072 16.617 18.9347 16.4445 18.9347 16.232V15.9763C18.9347 15.8531 18.9917 15.7437 19.0825 15.6744C19.1488 15.6236 19.2304 15.5913 19.3197 15.5913H19.3844H19.5754C19.7879 15.5913 19.9604 15.7638 19.9604 15.9763V16.232Z",
    fill: "#15584F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefund);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refund.55b6a62067d7d290329946982460c2c9.svg";